import {productTypes, systemTypes, chemicalBaseTypes, countries} from 'helpers/constants';
import _ from 'lodash';
import {usProducts, caProducts} from 'helpers/truBlueProductsConstants';


function getProductTypeCodes(products, productType) {
  switch (productType) {
    case productTypes.sanitizer:
      return products.sanitizers;

    case productTypes.maintOxidizer:
      return products.maintOxidizers;

    case productTypes.prevAlgicide:
      return products.prevAlgicides;

    case productTypes.maintClarifier:
      return products.maintClarifiers;

    default:
      return [];
  }
}

function getProductCodes(dealer, chemicalBaseType, productType) {
  let countryProducts = dealer.country === countries.US ? usProducts : caProducts;
  let productCodes = [];

  switch(chemicalBaseType) {
    case chemicalBaseTypes.chlorinePool:
    case chemicalBaseTypes.synergyPool:
      productCodes =  getProductTypeCodes(countryProducts.chlorinePool, productType); break;
    case chemicalBaseTypes.saltWaterPool: productCodes = getProductTypeCodes(countryProducts.saltWaterPool, productType); break;
    case chemicalBaseTypes.mineralSpringsPool: productCodes = getProductTypeCodes(countryProducts.mineralSpringsPool, productType); break;
    default: {
    //If no chemical base type get codes for all chemicals
      let allProducts = [];

      allProducts = allProducts.concat(getProductTypeCodes(countryProducts.chlorinePool, productType));
      allProducts = allProducts.concat(getProductTypeCodes(countryProducts.saltWaterPool, productType));
      allProducts = allProducts.concat(getProductTypeCodes(countryProducts.mineralSpringsPool, productType));

      productCodes =  _.uniq(allProducts);
    }
  }

  return productCodes;
}

export function truBlueSanitizers(products, dealer, chemicalBaseType) {
  const wardenIDs = getProductCodes(dealer, chemicalBaseType, productTypes.sanitizer);
  const productWithinCountry = products.filter(p => p.country === dealer.country);

  return productWithinCountry
    .filter(x => x.productTypeID === productTypes.sanitizer && x.poolTypeID === systemTypes.pool && wardenIDs.includes(x.wardenID))
    .sort((a, b) => a.order < b.order ? -1 : 1);
}

export function truBlueMaintOxidizers(products, dealer, chemicalBaseType) {
  const wardenIDs = getProductCodes(dealer, chemicalBaseType, productTypes.maintOxidizer);
  const productWithinCountry = products.filter(p => p.country === dealer.country);

  return productWithinCountry // Don't want all options listed here for different chemical base types
    .filter(x => x.productTypeID === productTypes.maintOxidizer && x.poolTypeID === systemTypes.pool &&
      x.chemicalBaseTypeID === chemicalBaseType && wardenIDs.includes(x.wardenID))
    .sort((a, b) => a.order < b.order ? -1 : 1);
}

export function truBluePrevAlgicides(products, dealer, chemicalBaseType) {
  const wardenIDs = getProductCodes(dealer, chemicalBaseType, productTypes.prevAlgicide);
  const productWithinCountry = products.filter(p => p.country === dealer.country);

  return productWithinCountry
    .filter(x => x.productTypeID === productTypes.prevAlgicide && x.poolTypeID === systemTypes.pool &&
      x.chemicalBaseTypeID === chemicalBaseType && wardenIDs.includes(x.wardenID))
    .sort((a, b) => a.order < b.order ? -1 : 1);
}

export function truBlueMaintClarifiers(products, dealer, chemicalBaseType) {
  const wardenIDs = getProductCodes(dealer, chemicalBaseType, productTypes.maintClarifier);
  const productWithinCountry = products.filter(p => p.country === dealer.country);

  return productWithinCountry
    .filter(x => x.productTypeID === productTypes.maintClarifier && x.poolTypeID === systemTypes.pool &&
      x.chemicalBaseTypeID === chemicalBaseType && wardenIDs.includes(x.wardenID))
    .sort((a, b) => a.order < b.order ? -1 : 1);
}

export function namesAndIDs(xs) {
  return [xs.map(x => x.name), xs.map(x => x.id)];
}

function _inProductList(products, id) {
  return products.filter(x => x.id === id).length === 1;
}

export function isProductTruBlue(products, productType, dealer, chemicalBaseType, x) {
  switch (productType) {
    case productTypes.sanitizer:
      return _inProductList(truBlueSanitizers(products, dealer, chemicalBaseType), x);

    case productTypes.maintOxidizer:
      return _inProductList(truBlueMaintOxidizers(products, dealer, chemicalBaseType), x);

    case productTypes.prevAlgicide:
      return _inProductList(truBluePrevAlgicides(products, dealer, chemicalBaseType), x);

    case productTypes.maintClarifier:
      return _inProductList(truBlueMaintClarifiers(products, dealer, chemicalBaseType), x);

    default:
      return false;
  }
}
